import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs"
import { Button } from "../../../ui/button"
import { Checkbox } from "../../../ui/checkbox"

import { Input } from "../../../ui/input"
import { Row, Col } from "../../../ui/RowCol"

import { Textarea } from "../../../ui/textarea"
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
} from "../../../ui/select"
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    CommandSeparator,
    CommandShortcut,
} from "../../../ui/command"
import styled from "styled-components"

const ExportData = () => {

    return (
        <MainContainer>
            <Title>輸出檔案</Title>
            <Tabs defaultValue="bibliographic" className="w-full">
                <TabsList>
                    <TabsTrigger value="bibliographic">輸出書目記錄</TabsTrigger>
                    <TabsTrigger value="authority">輸出權限紀錄</TabsTrigger>
                </TabsList>
                <TabsContent value="bibliographic"><ExportBiliographicRecord /></TabsContent>
                <TabsContent value="authority"><ExportAuthorityRecords /></TabsContent>
            </Tabs>
        </MainContainer>
    )
}
const ExportAuthorityRecords = () => {
    return (
        <>
            <MainContainer>
                <WhiteBox>
                    <SubTitle>Select records to export </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                From authid:
                            </GrayText>
                            <Input className='w-28' />
                        </ItemBox>
                    </ItemContainer>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                To authid:
                            </GrayText>
                            <Input className='w-28' />
                        </ItemBox>
                    </ItemContainer>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                Authority type:
                            </GrayText>
                            <Select className='mr-2'>
                                <SelectTrigger className="w-[180px]">
                                    <SelectValue placeholder="--All--" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectGroup>
                                        <SelectLabel>Authority type</SelectLabel>
                                        <SelectItem value="Default">Default</SelectItem>
                                        <SelectItem value="Chronological Term">Chronological Term</SelectItem>
                                        <SelectItem value="Genre/Form Term">Genre/Form Term</SelectItem>
                                        <SelectItem value="Geographic Name">Geographic Name </SelectItem>
                                        <SelectItem value="Meeting Name">Meeting Name </SelectItem>
                                        <SelectItem value="Personal Name">Personal Name </SelectItem>
                                        <SelectItem value="Topical Term">Topical Term </SelectItem>
                                        <SelectItem value="UNIF_TITLE">Uniform Title </SelectItem>


                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                        </ItemBox>
                    </ItemContainer>
                    <SubTitle>Use a file </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <div className=" text-gray-500">
                            File containing a list of authids with one authid per line. This list works as a filter: it is compatible with other parameters. (File types accepted: .csv and .txt)                            </div>
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                File
                            </GrayText>
                            <Input type='file' className='w-46' />
                        </ItemBox>
                    </ItemContainer>
                    <SubTitle>Options </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                            Don't export fields:
                            </GrayText>
                            <Input className='w-36' />
                            <span className='text-gray-500'>
                                separate by a blank. (e.g., 100a 200 606)
                            </span >
                        </ItemBox>
                    </ItemContainer>
                    <SubTitle>Options format </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                File format:
                            </GrayText>
                            <Select className='mr-2'>
                                <SelectTrigger className="w-[180px]">
                                    <SelectValue placeholder="Choose" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectGroup>
                                        <SelectLabel>Lost status</SelectLabel>
                                        <SelectItem value="A">A</SelectItem>
                                        <SelectItem value="B">B</SelectItem>
                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                File Name:
                            </GrayText>
                            <Input className='w-36' defaultValue='koha.mrc' />
                        </ItemBox>

                    </ItemContainer>
                    <Button className='mt-3' variant='outline' >
                        Export bibliographic record
                    </Button>
                </WhiteBox>
            </MainContainer>


        </>
    )
}
const ExportBiliographicRecord = () => {

    return (
        <>
            <MainContainer>
                <WhiteBox>
                    <SubTitle>Select records to export </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                From biblionumber:
                            </GrayText>
                            <Input className='w-28' />
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                to biblionumber:
                            </GrayText>
                            <Input className='w-28' />

                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                Item type:
                            </GrayText>
                            <div>
                                <select className="border rounded" multiple>
                                    <option value="audi">--ALL--</option>
                                    <option value="byd">Books</option>
                                    <option value="geely">Computer Files</option>
                                    <option value="volvo">Continuib Files</option>
                                </select>

                            </div>
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                With items ownned by the following libraries:
                            </GrayText>
                            <div>
                                <Row gutter={[16, 16]}>
                                    <Col>
                                        ✓ Select all
                                    </Col>
                                    <Col>
                                        |
                                    </Col>
                                    <Col>
                                        X Clear all
                                    </Col>
                                </Row>
                                <Row className='my-2' gutter={[16, 16]}>
                                    <Col >
                                        <Row className='border rounded-lg px-2 ' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Centerville
                                        </Row>
                                    </Col>
                                    <Col >
                                        <Row className='border rounded-lg px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Fairfield
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className='border rounded-lg px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Fairview
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className='border rounded-lg px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Franklin
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className='my-2' gutter={[16, 16]}>
                                    <Col>
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Institut Protestant de
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Theologie
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Liberty
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Midway
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Pleasant Valley
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className='my-2' gutter={[16, 16]}>
                                    <Col>
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Riverside
                                        </Row>
                                    </Col>
                                    <Col >
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Springfield
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Troy
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row className='border rounded-lg  px-2' align={'middle'} justify={'space-around'}>
                                            <Checkbox className='mr-2' /> Union
                                        </Row>
                                    </Col>
                                </Row>

                            </div>
                        </ItemBox>
                    </ItemContainer>
                    <SubTitle>Select records to export </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                From item call number:
                            </GrayText>
                            <Input className='w-28' />
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                To item call number:
                            </GrayText>
                            <Input className='w-28' />
                        </ItemBox>
                    </ItemContainer>
                    <SubTitle>Accession date (inclusive) </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                Start date:
                            </GrayText>
                            <Input type='date' className='w-36' />
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                End date:
                            </GrayText>
                            <Input type='date' className='w-36' />
                        </ItemBox>
                    </ItemContainer>
                    <SubTitle>Use a file </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <div className=" text-gray-500">
                                File containing a list of authids with one authid per line. This list works as a filter: it is compatible with other parameters. (File types accepted: .csv and .txt)
                            </div>
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                File
                            </GrayText>
                            <Input type='file' className='w-46' />
                        </ItemBox>
                    </ItemContainer>
                    <SubTitle>Options </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                Don't export items:
                            </GrayText>
                            <Checkbox />
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                Remove items not owned by selected libraries:
                            </GrayText>
                            <Checkbox />
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                Don't export fields:
                            </GrayText>
                            <Input className='w-36' />
                            <span className='text-gray-500'>
                                separate by a blank. (e.g., 100a 200 606)
                            </span >
                        </ItemBox>
                    </ItemContainer>
                    <SubTitle>Options format </SubTitle>
                    <ItemContainer>
                        <ItemBox>
                            <GrayText>
                                File format
                            </GrayText>
                            <Select className='mr-2'>
                                <SelectTrigger className="w-[180px]">
                                    <SelectValue placeholder="Choose" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectGroup>
                                        <SelectLabel>Lost status</SelectLabel>
                                        <SelectItem value="A">A</SelectItem>
                                        <SelectItem value="B">B</SelectItem>
                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                        </ItemBox>
                        <ItemBox>
                            <GrayText>
                                File Name
                            </GrayText>
                            <Input className='w-36' defaultValue='koha.mrc' />
                        </ItemBox>

                    </ItemContainer>
                    <Button className='mt-3' variant='outline' >
                        Export bibliographic record
                    </Button>
                </WhiteBox>

            </MainContainer>

        </>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`
const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: 100%;
`

const GrayText = styled.div`
color: #929292;
width: 8em;
text-align: end;
padding-right: 1em;
`

const ItemTitle = styled.div`
color: #929292;
text-align: left;
font-size: 1.1em;
font-weight: 600;
`

const ItemContainer = styled.div`
margin-bottonm:40px;
// width: fit-content;
`

const ItemBox = styled.div`
padding: 0.1em;
margin-left: 1em;
/* width: fit-content; */
// border-bottom: 1px solid #d4d4d4;
display: flex;
flex-direction: row;
flex-wrap: nowrap;
align-items: center;
`

export default ExportData